/**
 * EV Plug: keeps the discount badge in the product page price row (snippets/m_sale-badge.liquid)
 * in step with the selected variant. The texts per variant come translated from Liquid.
 */
if (!customElements.get('sale-badge')) {
  class SaleBadge extends HTMLElement {
    connectedCallback() {
      try {
        this.texts = JSON.parse(this.dataset.texts || '{}');
      } catch (e) {
        this.texts = {};
      }
      this.textEl = this.querySelector('.js-sale-badge-text');
      this.onVariantChange = this.onVariantChange.bind(this);
      document.addEventListener('on:variant:change', this.onVariantChange);
    }

    disconnectedCallback() {
      document.removeEventListener('on:variant:change', this.onVariantChange);
    }

    onVariantChange(evt) {
      const { product, variant } = evt.detail || {};
      if (product && String(product.id) !== this.dataset.productId) return;

      const text = variant ? this.texts[variant.id] : null;
      if (text) this.textEl.innerHTML = text;
      this.hidden = !text;
    }
  }

  customElements.define('sale-badge', SaleBadge);
}
